import { gql } from '@apollo/client'

export const PREVIEW_UNIT_QUANTITY_CHANGE_INVOICE = gql`
  query PreviewUnitQuantityChangeInvoice(
    $input: UpdateSubscriptionUnitQuantityInput!
  ) {
    previewUnitQuantityChangeInvoice(input: $input) {
      subtotal
      totalTaxes
      total
      amountDue
      currency
      lines {
        amount
        description
        currency
      }
    }
  }
`
